export const EVENT_UPDATED_NOTIFICATION_URL_PARAM_NAME = 'event_updated';
export const EVENT_UPDATED_NOTIFICATION_URL_PARAM_SHOW_VALUE = '1';
